import ContactInfo from "../components/Contact/ContactInfo";
import { useLoadScript } from "@react-google-maps/api";
import Map from "../components/Contact/Map";
import { Link } from "react-router-dom";

function Contact() {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "",
  });
  let userId = localStorage.getItem("userId");
  return (
    <div className="min-h-screen bg-kedifapgreen-100 flex flex-col items-center justify-center p-6 md:p-10">
      {/* {!userId && (
        <Link className="inline-block mb-4 text-kedifapgreen-400 font-medium hover:underline" to="/app">
          ← Back to Login
        </Link>
      )} */}
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">
            Στοιχεία Επικοινωνίας
          </h1>
          <div className="mt-2 h-1 w-64 bg-kedifapgreen-400 rounded-full" />
        </div>
        <ContactInfo />
      </div>
      {isLoaded && (
        <div className="max-w-4xl mx-auto mt-6 rounded-2xl overflow-hidden shadow-lg">
          <Map />
        </div>
      )}
      <div className="mt-6">
        <Link
          to="/app"
          className="inline-flex items-center gap-2 text-kedifapgreen-400 font-medium hover:underline"
        >
          ← Μετάβαση στην Αρχική
        </Link>
      </div>
    </div>
  );
}

export default Contact;
